import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

interface UserBadgeProps {
  isActive?: boolean;
}

const UserBadge = ({ isActive }: UserBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge variant={isActive ? "secondary" : "destructive"}>
      {isActive ? t("users.status.active") : t("users.status.inactive")}
    </Badge>
  );
};

export default UserBadge;
